// extracted by mini-css-extract-plugin
module.exports = {"mweydr9":"mweydr9","tagging":"tagging"};